export const generatePDF = (base64Pdf: string, name: string) => {
  try {
    const binaryPdf = atob(base64Pdf)
    const arrayBuffer = new ArrayBuffer(binaryPdf.length)
    const uint8Array = new Uint8Array(arrayBuffer)
    for (let i = 0; i < binaryPdf.length; i++) {
      uint8Array[i] = binaryPdf.charCodeAt(i)
    }
    const blob = new Blob([uint8Array], {type: 'application/pdf'})
    const blobUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = `${name}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Error generating PDF:', error)
  }
}
